import moment from "moment";

export const getLocalizedMonth = (monthIndex) => {
  const formattedMonth = moment().month(monthIndex).format("MMMM").split("");
  const firstLetter = formattedMonth.shift();
  return firstLetter.toUpperCase() + formattedMonth.join("");
};